const scan_options = {
  getMyScanOptions() {
    const defaults = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/scan_options/setting', defaults);
  },
  setMyScanOptions(data) {
    const defaults = {
      method: 'PUT',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/scan_options/setting', Object.assign(defaults, { data }));
  },
  getNewScanOption() {
    const defaults = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/reports/new_scan_option', defaults);
  },
  getCycloneDxOption() {
    const defaults = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/cyclone_dx_option/setting', defaults);
  },
  setCycloneDxOption(data) {
    const defaults = {
      method: 'PUT',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request(
      '/1/cyclone_dx_option/setting',
      Object.assign(defaults, { data })
    );
  },
};
export default scan_options;
